<template>
    <div class="MemberAreaContent__left" :class="{'is-open': isOpen}">
        <div class="ChatContacts">
            <div class="ChatContacts__head">
                <button class="ChatContacts__head-back" @click.prevent="$emit('close')">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <h3 class="ChatContacts__head-title">Contacts</h3>
                <button class="ChatContacts__head-new" @click.prevent="newDiscussion">Nouveau</button>
            </div>
            <div class="ChatContacts__search">
                <div class="ChatContacts__search-form">
                    <input class="ChatContacts__search-input"
                           v-model="search"
                           type="text"
                           placeholder="Rechercher..."/>
                </div>
            </div>
            <div v-if="loading && discussions.length < 1" class="ChatContacts__loader">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
            <ul class="ChatContacts__list">
                <contact
                    v-for="discussion in visibleDiscussions"
                    :discussion="discussion"
                    @opening="$emit('close')"
                />
            </ul>
        </div>
    </div>
</template>

<script>
    import {actions, getters, mutations} from "../../store";
    import {chatFormatTime} from "../../utils";
    import Contact from "./Contact";

    export default {
        components: {Contact},
        props: ['isOpen'],
        data: function () {
            return {
                loading: false,
                search: ''
            }
        },
        computed: {
            discussions: getters.discussions,
            visibleDiscussions: function () {
                return this.discussions.filter(discussion => getters.discussionName(discussion.id).toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
            }
        },
        methods: {
            chatFormatTime,
            newDiscussion: function () {
                mutations.closeDiscussion();
                mutations.clearNewContactId();
                this.$emit('close')
            }
        },
        async created() {
            this.loading = true;
            await actions.fetchDiscussions();
            this.loading = false;
        }
    }
</script>
